// Module
var code = "<template>\n    <li tabindex=\"0\" keypress.trigger=\"handleKeypress($event)\" click.delegate=\"select()\" class.bind=\"isActive ? 'active' : ''\" resource.bind=\"labelResource\"></li>\n</template>\n";
// Exports
export default code;